import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

// ── Skills Cloud (/skills) ────────────────────────────────────────────
export const skillsApi = {
  listSkills: (params) => api.get('/skills', { params }).then(unwrap),
  getTree: () => api.get('/skills/tree').then(unwrap),
  getSkill: (id) => api.get(`/skills/${id}`).then(unwrap),
  createSkill: (payload) => api.post('/skills', payload).then(unwrap),
  updateSkill: (id, patch) => api.patch(`/skills/${id}`, patch).then(unwrap),
  deleteSkill: (id) => api.delete(`/skills/${id}`).then(unwrap),

  listEmployeeSkills: (params) => api.get('/skills/employee-skills', { params }).then(unwrap),
  addEmployeeSkill: (payload) => api.post('/skills/employee-skills', payload).then(unwrap),
  updateEmployeeSkill: (id, patch) => api.patch(`/skills/employee-skills/${id}`, patch).then(unwrap),
  removeEmployeeSkill: (id) => api.delete(`/skills/employee-skills/${id}`).then(unwrap),
  getProfile: (employeeId) => api.get(`/skills/employees/${employeeId}/profile`).then(unwrap),

  listEndorsements: (esId) => api.get(`/skills/employee-skills/${esId}/endorsements`).then(unwrap),
  endorse: (esId, payload) => api.post(`/skills/employee-skills/${esId}/endorse`, payload).then(unwrap),

  gap: (params) => api.get('/skills/gap', { params }).then(unwrap),
};

// ── Talent (/talent) ──────────────────────────────────────────────────
export const talentApi = {
  // goals
  listGoals: (params) => api.get('/talent/goals', { params }).then(unwrap),
  getGoal: (id) => api.get(`/talent/goals/${id}`).then(unwrap),
  createGoal: (payload) => api.post('/talent/goals', payload).then(unwrap),
  updateGoal: (id, patch) => api.patch(`/talent/goals/${id}`, patch).then(unwrap),
  deleteGoal: (id) => api.delete(`/talent/goals/${id}`).then(unwrap),
  listCheckins: (id) => api.get(`/talent/goals/${id}/checkins`).then(unwrap),
  addCheckin: (id, payload) => api.post(`/talent/goals/${id}/checkins`, payload).then(unwrap),
  rollupGoal: (id) => api.put(`/talent/goals/${id}/rollup`).then(unwrap),

  // calibration
  listSessions: (params) => api.get('/talent/calibration', { params }).then(unwrap),
  getSession: (id) => api.get(`/talent/calibration/${id}`).then(unwrap),
  createSession: (payload) => api.post('/talent/calibration', payload).then(unwrap),
  updateSession: (id, patch) => api.patch(`/talent/calibration/${id}`, patch).then(unwrap),
  startSession: (id) => api.put(`/talent/calibration/${id}/start`).then(unwrap),
  addParticipant: (id, employeeId) => api.post(`/talent/calibration/${id}/participants`, { employeeId }).then(unwrap),
  upsertRating: (id, payload) => api.put(`/talent/calibration/${id}/ratings`, payload).then(unwrap),
  distribution: (id) => api.get(`/talent/calibration/${id}/distribution`).then(unwrap),
  finalize: (id) => api.put(`/talent/calibration/${id}/finalize`).then(unwrap),

  // succession
  listPlans: () => api.get('/talent/succession').then(unwrap),
  getPlan: (id) => api.get(`/talent/succession/${id}`).then(unwrap),
  createPlan: (payload) => api.post('/talent/succession', payload).then(unwrap),
  updatePlan: (id, patch) => api.patch(`/talent/succession/${id}`, patch).then(unwrap),
  deletePlan: (id) => api.delete(`/talent/succession/${id}`).then(unwrap),
  benchStrength: (id) => api.get(`/talent/succession/${id}/bench-strength`).then(unwrap),
  addCandidate: (id, payload) => api.post(`/talent/succession/${id}/candidates`, payload).then(unwrap),
  updateCandidate: (id, patch) => api.patch(`/talent/succession-candidates/${id}`, patch).then(unwrap),
  removeCandidate: (id) => api.delete(`/talent/succession-candidates/${id}`).then(unwrap),

  // talent pools
  listPools: () => api.get('/talent/pools').then(unwrap),
  getPool: (id) => api.get(`/talent/pools/${id}`).then(unwrap),
  createPool: (payload) => api.post('/talent/pools', payload).then(unwrap),
  updatePool: (id, patch) => api.patch(`/talent/pools/${id}`, patch).then(unwrap),
  deletePool: (id) => api.delete(`/talent/pools/${id}`).then(unwrap),
  addMember: (id, employeeId) => api.post(`/talent/pools/${id}/members`, { employeeId }).then(unwrap),
  removeMember: (memberId) => api.delete(`/talent/pool-members/${memberId}`).then(unwrap),
};
